import { ENUM__network_event_server_to_client as ENE } from '@shared/network/ENUM__network_event_server_to_client';
import { add_socket_handler_client as add } from '../_methods/add_socket_handler_client';
import { HANDLER_CLIENT__generation_graph_fields_upsert } from './generation/HANDLER_CLIENT__generation_graph_fields_upsert';
import { HANDLER_CLIENT__generation_next_created } from './generation/HANDLER_CLIENT__generation_next_created';
import { HANDLER_CLIENT__generations_upsert } from './generation/HANDLER_CLIENT__generations_upsert';

export function add_socket_handlers_client_generation() {
  add(ENE.GENERATION_FAILED, () => {}); //mb need to handle this
  add(ENE.GENERATIONS_UPSERT, HANDLER_CLIENT__generations_upsert);

  add(ENE.GENERATION_NEXT_CREATED, HANDLER_CLIENT__generation_next_created);
  add(ENE.GENERATION_GRAPH_FIELDS_UPSERT, HANDLER_CLIENT__generation_graph_fields_upsert);
}
